// Submits a PayFast hidden-form to redirect the browser to the gateway.
export function submitPayFast({ action_url, fields }) {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = action_url;
  form.style.display = "none";
  Object.entries(fields).forEach(([k, v]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = k;
    input.value = String(v ?? "");
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
}
